import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';

// Exemplo de sugestões
//  const suggestions = [{name: 'Maçã'}, {name: 'Banana'}, {name: 'Bola'}, {name: 'Cereja'}, {name: 'Damasco'}, {name: 'Figo'}];

const getSuggestions = (value, suggestions) => {
    debugger;
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : suggestions.filter(item => item.toLowerCase().slice(0, inputLength) === inputValue);
};

const renderSuggestion = suggestion => (
    <div className="px-4 py-2  hover:bg-blue-200  bg-white cursor-pointer border dark:text-white dark:bg-gray-800 dark:border-gray-500 dark:hover:bg-blue-500 z-50 absolute" style={{zIndex: 9999}}>
        {suggestion}
    </div>
);

class InputSuggest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || '',
            suggestions: [],
        };
    }

    onChange = (event, {newValue}) => {
        this.setState({
            value: newValue,
        });
        this.props.onChange(newValue);
    };

    onSuggestionsFetchRequested = ({value}) => {
        const {suggestions} = this.props;
        this.setState({
            suggestions: getSuggestions(value, suggestions),
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    render() {
        const {value, suggestions} = this.state;
        const {disabled} = this.props;

        // Configuração do Autosuggest
        const inputProps = {
            value,
            onChange: this.onChange,
            disabled: disabled,
            className:
                'w-full px-4 py-2 rounded-[8px] border border-gray-300 focus:outline-none focus:border-blue-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ' +
                (disabled ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'),
        };

        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={suggestion => suggestion}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        );
    }
}

export default InputSuggest;
